<template>
  <v-card :color="'rgb(250, 250, 250)'" class="elevation-0">
    <v-toolbar dense :color="colorBarraFormulario" dark flat>
      <v-toolbar-title v-bind:style="{ color: colorFondoDialog }">
        <span v-bind:style="{ color: 'white' }">Perfil del Cliente</span>
      </v-toolbar-title>
      <v-spacer></v-spacer>

      <v-tooltip v-if="modelCliente.email" bottom>
        <template v-slot:activator="{ on }">
          <v-icon
            @click="_enviarEmail(modelCliente)"
            :color="colorAccent3"
            class="mt-1 mb-1 mr-2"
            v-on="on"
            >mdi-email</v-icon
          >
        </template>
        <span>Enviar Correo</span>
      </v-tooltip>

      <v-tooltip v-if="modelCliente.telefono" bottom>
        <template v-slot:activator="{ on }">
          <v-icon
            @click="_abrirWh(modelCliente)"
            :color="colorAccent3"
            class="mt-1 mb-1 mr-4"
            v-on="on"
            >mdi-whatsapp</v-icon
          >
        </template>
        <span>Enviar Whatsapp</span>
      </v-tooltip>
      <v-chip
          class="mr-4 px-10"
          label
          :color="colorAccent1"
          text-color="white"
          link
          @click="_guardarCliente"
        >
          <span v-if="loading" v-bind:style="{ color: 'white' }">Guardando...</span>
          <span v-else v-bind:style="{ color: 'white' }">Guardar</span>
        </v-chip>
      <v-icon size="30" :color="'white'" @click="_cerrarVentana"
        >mdi-close-circle</v-icon
      >
    </v-toolbar>
    <v-card-text>
      <v-row class="mt-6" dense>
        <v-col class="ml-0">


          <v-row dense class="mx-4">
            <v-select outlined dense :dark="dark" autocomplete="off" v-model="modelCliente.tipoCliente" label="Tipo de Cliente"
              :items="tiposCliente"></v-select>
          </v-row>


          <v-row dense class="mx-4">
            <v-text-field
              v-model="modelCliente.nombre"
              outlined
              label="Nombre"
              dense
              :dark="dark"
              autocomplete="off"
            ></v-text-field>
          </v-row>

          <v-row dense class="mx-4">
            <v-text-field
              v-model="modelCliente.apellidos"
              outlined
              label="Apellidos"
              dense
              :dark="dark"
              autocomplete="off"
            ></v-text-field>
          </v-row>

          
          <v-row dense class="mx-4">
            <v-text-field
              outlined
              dense
              v-model="modelCliente.documento"
              :dark="dark"
              label="Documento"
              maxlength="150"
            ></v-text-field>
          </v-row>

          <v-row dense class="mx-4">
            <v-text-field
              outlined
              dense
              v-model="modelCliente.pasaporteNumero"
              :dark="dark"
              label="Pasaporte"
              maxlength="150"
            ></v-text-field>
          </v-row>

          <v-row dense class="mx-4">
            <v-text-field
              outlined
              dense
              :dark="dark"
              autocomplete="off"
              v-model="modelCliente.telefono"
              label="Teléfono"
              :rules="[rules.telefono]"
            ></v-text-field>
          </v-row>

          <v-row dense class="mx-4">
            <v-text-field
              outlined
              dense
              v-model="modelCliente.email"
              :dark="dark"
              label="Email"
              maxlength="150"
              :rules="[rules.email]"
            ></v-text-field>
          </v-row>


          <v-row dense class="mx-4">
            <v-text-field
              outlined
              dense
              v-model="modelCliente.direccion"
              :dark="dark"
              label="Dirección"
              maxlength="150"
            ></v-text-field>
          </v-row>

          <v-row dense class="mx-4">
            <v-textarea
              outlined
              v-model="modelCliente.comentarios"
              :dark="dark"
              label="Comentarios"
            ></v-textarea>
          </v-row>

         
        </v-col>

        <v-divider
          v-if="
            modelCliente &&
            modelCliente.reservas &&
            modelCliente.reservas.length > 0
          "
          class="ml-4 mr-4 mt-0"
          :dark="dark"
          vertical
        />

        <v-col
          class="ml-4 mr-2"
          v-if="
            modelCliente &&
            modelCliente.reservas &&
            modelCliente.reservas.length > 0
          "
        >
          <v-row>
            <v-data-table
              v-if="modelCliente.reservas"
              dense
              hide-default-footer
              hide-default-header
              :headers="headersLargo"
              :items="modelCliente.reservas"
              :items-per-page="300"
              class="elevation-0 mt-2"
              :group-by="['fecha_inicio']"
            >
              <template v-slot:group="{ items }">
                <tr v-for="item in items" :key="item.id" v-show="!item.hide">
                  <td
                    v-bind:style="{ color: 'white', background: colorAccent3 }"
                  >
                    <v-row class="mx-2">
                      <span style="color: white; font-size: 12px">{{
                        item["fecha_inicio"] + " ___ " + item["fecha_llegada"]
                      }}</span>
                    </v-row>
                    <v-row class="mx-2">
                      <span style="color: white; font-size: 12px">{{
                        item["camino"]["titulo"] 
                      }}</span>
                    </v-row>
                  </td>

                  
                </tr>
              </template>

              <template v-slot:no-data>
                <v-row class="mt-1 ml-4" justify="start" dense></v-row>
              </template>
            </v-data-table>
          </v-row>
        </v-col>
      </v-row>

    
    </v-card-text>
  </v-card>
</template>

<script>
import { mapState, mapActions, mapMutations } from "vuex";

export default {
  name: "ClienteFormulario",
  components: {},
  data: () => ({
    loading: false,
    headersLargo: [
      {
        text: "fecha_inicio",
        align: "center",
        sortable: false,
        value: "fecha_inicio",
      },
     
    ],

    rules: {
        telefono:  
        value => {
          const phonePattern = /^(\+?[0-9]{1,3}[-\s]?)?(\(?[0-9]{1,4}\)?[-\s]?)?[0-9]{1,10}([-\s]?[0-9]{1,6})?$/;
          if (!value) {
            return true;
          }
          return phonePattern.test(value) || "Teléfono inválido";
        }
      ,
        email: value => {
          const pattern = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i;
          if (!value) {
            return true;
          }
          return pattern.test(value) || 'Correo electrónico no válido';
        },
      },
  }),

  props: {
    modelCliente: {
      type: Object,
      required: true,
    },

    accion: {
      type: String,
      required: true,
    },
  },

  computed: {
    ...mapState([
      "drawer",
      "dark",
      "colorAccent1",
      "colorAccent2",
      "colorAccent3",
      "colorFondoDialog",
      "colorBarraFormulario",
      "tiposCliente",
    ]),
    ...mapState("auth", [
      "user",
      "date",
      "access_token",
      "error",
      "errorMessage",
    ]),
  },

  /*modelCliente() {
      if (this.modelCliente.id == null) {
        this.accion = "crear";
      } else {
        this.accion = "editar";
      }
    }, */

  mounted() {
    /* if (this.modelCliente.id == null) {
      this.accion = "crear";
    } else {
      this.accion = "editar";
    }*/
  },

  methods: {
    ...mapActions("clientes", ["getClientes", "crearCliente", "updateCliente"]),

    _enviarEmail(item) {
      if (item.email != null) {
       // Si se hace desde una aplicacion de escritorio electron 
        /*require("electron").shell.openExternal(
          "https://mail.google.com/mail?view=cm&tf=0&to=" + item.email
        );*/
        window.open("https://mail.google.com/mail?view=cm&tf=0&to=" + item.email, '_blank');
      }
    },

    _abrirWh(item) {
      if (item.telefono != null) {
         // Si se hace desde una aplicacion de escritorio electron
       /* require("electron").shell.openExternal(
          "https://api.whatsapp.com/send?phone=34" + item.telefono.replace(" ", ""),
          "_blank"
        );*/
        window.open("https://api.whatsapp.com/send?phone=34" + item.telefono.replace(" ", ""), '_blank');
      }
    },

    _captionFecha(item) {
      if (item && item.fecha) {
        return (
          this._diasemana(item.fecha) +
          " " +
          item.fecha.substring(8, 10) +
          "-" +
          item.fecha.substring(5, 7) +
          "-" +
          item.fecha.substring(0, 4)
        );
      } else {
        return "";
      }
    },

    _diasemana(date) {
      let days = [
        "Lunes",
        "Martes",
        "Miércoles",
        "Jueves",
        "Viernes",
        "Sábado",
        "Domingo",
      ];
      let d = new Date(date.substring(0, 10));
      let dd = d.getUTCDay();
      if (dd > 0) {
        return days[d.getUTCDay() - 1];
      } else {
        return days[6];
      }
    },

    _cerrarVentana() {
      this.$emit("cerrarFormularioCliente");
    },

    async _guardarCliente() {
      this.loading = true;
      if (this.accion == "crear") {
        var res = await this.crearCliente([
          this.access_token,
          this.modelCliente,
        ]);
        const params = {};
        this._cerrarVentana();
        await this.getClientes([this.access_token, params, true]);
      } else if (this.accion == "editar") {
        var res = await this.updateCliente([
          this.access_token,
          this.modelCliente,
        ]);
        this._cerrarVentana();
      }
      this.loading = false;
    },
  },
};
</script>
